import useSWR from 'swr'

const useSearchJokes = searchTerm => {
  const { data, error } = useSWR(
    searchTerm ? `/search?term=${searchTerm}` : null
  )

  return {
    data: data?.results ?? [],
    loading: !data?.results?.length > 0 && !error,
    error: error,
  }
}

export default useSearchJokes
